// apiUrlHelper.js

// const baseUrl = 'http://localhost:3001/';
// const baseUrl = 'http://154.62.109.243:3002/';
const baseUrl = 'https://panelapi.veekayassociates.com/';

// Authentication
const loginUrl = () => {
  return baseUrl + 'auth/login';
};

const otpVerification = () => {
  return baseUrl + 'auth/verifyLoginOtp';
};

// Users
const getUsers = () => {
  return baseUrl + 'user/getUsers';
};

const createUser = () => {
  return baseUrl + 'user/createUser';
};

const updateUser = () => {
  return baseUrl + 'user/updateUser';
};

const deleteUser = () => {
  return baseUrl + 'user/deleteUser';
};

const transferLeads = () => {
  return baseUrl + 'user/transferLeads';
};

const getLeadRouting = () => {
  return baseUrl + 'user/getLeadRouting';
};

const updateLeadRouting = () => {
  return baseUrl + 'user/updateLeadRouting';
};

const getUserDashboard = () => {
  return baseUrl + 'user/getUserDashboard';
}

// Contacts
const getContacts = () => {
  return baseUrl + 'user/getContacts';
};

const createContact = () => {
  return baseUrl + 'user/createContact';
};

const updateContact = () => {
  return baseUrl + 'user/updateContact';
};

const deleteContact = () => {
  return baseUrl + 'user/deleteContact';
};

// Properties
const getProperties = () => {
  return baseUrl + 'user/getProperties';
};
const getProperty = () => {
  return baseUrl + 'user/getProperty';
};

const createProperty = () => {
  return baseUrl + 'user/createProperty';
};

const updateProperty = () => {
  return baseUrl + 'user/updateProperty';
};

const transferProperty = () => {
  return baseUrl + 'user/transferProperty';
};

const deleteProperty = () => {
  return baseUrl + 'user/deleteProperty';
};

// Leads
const getLeads = () => {
  return baseUrl + 'user/getLeads';
};

const getLeadsExportData = () => {
  return baseUrl + 'user/getLeadsExportData';
};

const getUniqueNames = () => {
  return baseUrl + 'user/getUniqueNames';
};

const getOppurtunities = () => {
  return baseUrl + 'user/getOppurtunities';
};

const getLeadHistory = () => {
  return baseUrl + 'user/getLeadHistory';
};

const getDashboardOppurtunitiesConversions = () => {
  return baseUrl + 'user/getDashboardOppurtunitiesConversions';
};

const getDashboardConversions = () => {
  return baseUrl + 'user/getDashboardConversions';
};

const getDashboardStackedData = () => {
  return baseUrl + 'user/getDashboardStackedData';
};

const createLead = () => {
  return baseUrl + 'user/createLead';
};

const updateLead = () => {
  return baseUrl + 'user/updateLead';
};

const deleteLead = () => {
  return baseUrl + 'user/deleteLead';
};

const getPropertySuggestions = () => {
  return baseUrl + 'user/getPropertySuggestions';
};

const getLeadSuggestions = () => {
  return baseUrl + 'user/getLeadSuggestions';
};

// Utils - Cities
const getCities = () => {
  return baseUrl + 'user/getCities';
};
const createUpdateCity = () => {
  return baseUrl + 'user/createUpdateCity';
}
const deleteCity = () => {
  return baseUrl + 'user/deleteCity';
}

// Utils - Localities
const getLocalities = () => {
  return baseUrl + 'user/getLocalities';
}
const getLocalitiesByCity = () => {
  return baseUrl + 'user/getLocalitiesByCity';
}
const createUpdateLocality = () => {
  return baseUrl + 'user/createUpdateLocality';
}
const deleteLocality = () => {
  return baseUrl + 'user/deleteLocality';
}

// Utils - Amenities
const getAmenities = () => {
  return baseUrl + 'user/getAmenities';
};
const createUpdateAmenity = () => {
  return baseUrl + 'user/createUpdateAmenity';
}
const deleteAmenity = () => {
  return baseUrl + 'user/deleteAmenity';
}

// Utils - Views
const getViews = () => {
  return baseUrl + 'user/getViews';
};
const createUpdateView = () => {
  return baseUrl + 'user/createUpdateView';
}
const deleteView = () => {
  return baseUrl + 'user/deleteView';
}

// Utils - Sources
const getSources = () => {
  return baseUrl + 'user/getSources';
};
const createUpdateSource = () => {
  return baseUrl + 'user/createUpdateSource';
}
const deleteSource = () => {
  return baseUrl + 'user/deleteSource';
}


// Utils - USPS
const getUsps = () => {
  return baseUrl + 'user/getUsps';
};
const createUpdateUsp = () => {
  return baseUrl + 'user/createUpdateUsp';
}
const deleteUsp = () => {
  return baseUrl + 'user/deleteUsp';
}


// Property Media
const getPropertyMedia = () => {
  return baseUrl + 'user/getPropertyMedia';
};
const createPropertyMedia = () => {
  return baseUrl + 'user/createPropertyMedia';
}
const updatePropertyMedia = () => {
  return baseUrl + 'user/updatePropertyMedia';
}
const deletePropertyMedia = () => {
  return baseUrl + 'user/deletePropertyMedia';
}

// Call Attempts
const getCallAttempts = () => {
  return baseUrl + 'user/getCallAttempts';
};
const getTodaysFollowupsAndBacklogs = () => {
  return baseUrl + 'user/getTodaysFollowupsAndBacklogs';
};
const getCallAttemptsByDate = () => {
  return baseUrl + 'user/getCallAttemptsByDate';
};
const createCallAttempt = () => {
  return baseUrl + 'user/createCallAttempt';
}
const updateCallAttempt = () => {
  return baseUrl + 'user/updateCallAttempt';
}
const deleteCallAttempt = () => {
  return baseUrl + 'user/deleteCallAttempt';
}

// Follow Ups
const getSiteVisits = () => {
  return baseUrl + 'user/getSiteVisits';
};
const getSiteVisitsByDate = () => {
  return baseUrl + 'user/getSiteVisitsByDate';
};
const createSiteVisit = () => {
  return baseUrl + 'user/createSiteVisit';
}
const updateSiteVisit = () => {
  return baseUrl + 'user/updateSiteVisit';
}
const deleteSiteVisit = () => {
  return baseUrl + 'user/deleteSiteVisit';
}

// ================== Notification Endpoints ================== //

// Fetch Notifications
const getNotifications = () => {
  return baseUrl + 'notification/getNotifications';
};

// Create Notification (Optional: If you need to create notifications via API)
const createNotification = () => {
  return baseUrl + 'notification/createNotification';
};

// Mark Notification as Read
const markAsRead = () => {
  return baseUrl + 'notification/markAsRead';
};

// =========================================================== //

const getDashboardData = () => {
  return baseUrl + 'user/getDashboardData';
};

const getDashboardLeads = () => {
  return baseUrl + 'user/getDashboardLeads';
};

const getDashboardProperties = () => {
  return baseUrl + 'user/getDashboardProperties';
};

const getAdminDataExport = () => {
  return baseUrl + 'user/getAdminDataExport';
};

const getDashboardSiteVisits = () => {
  return baseUrl + 'user/getDashboardSiteVisits';
};

const getDashboardCallAttempts = () => {
  return baseUrl + 'user/getDashboardCallAttempts';
};

const getDashboardBacklogs = () => {
  return baseUrl + 'user/getDashboardBacklogs';
};

const getSourcesData = () => {
  return baseUrl + 'user/getSourcesData';
};

const getTotalSourcesData = () => {
  return baseUrl + 'user/getTotalSourcesData';
};



// PROJECTS

const getProjects = () => {
  return baseUrl + 'user/getProjects';
};

const getProject = () => {
  return baseUrl + 'user/getProject';
};

const createProject = () => {
  return baseUrl + 'user/createProject';
};

const updateProject = () => {
  return baseUrl + 'user/updateProject';
};

const deleteProject = () => {
  return baseUrl + 'user/deleteProject';
};


// PROJECT CONFIG

const getProjectConfigs = () => {
  return baseUrl + 'user/getProjectConfigs';
};

const getProjectLeadSuggestions = () => {
  return baseUrl + 'user/getProjectLeadSuggestions';
};

const getProjectConfig = () => {
  return baseUrl + 'user/getProjectConfig';
};

const createProjectConfig = () => {
  return baseUrl + 'user/createProjectConfig';
};

const updateProjectConfig = () => {
  return baseUrl + 'user/updateProjectConfig';
};

const deleteProjectConfig = () => {
  return baseUrl + 'user/deleteProjectConfig';
};


// PROJECTS MEDIA

const getProjectMedia = () => {
  return baseUrl + 'user/getProjectMedia';
};
const createProjectMedia = () => {
  return baseUrl + 'user/createProjectMedia';
}
const updateProjectMedia = () => {
  return baseUrl + 'user/updateProjectMedia';
}
const deleteProjectMedia = () => {
  return baseUrl + 'user/deleteProjectMedia';
}

// Logs
const getLogs = () => {
  return baseUrl + 'user/getLogs';
};

// Tags

const getTags = () => {
  return baseUrl + 'user/getTags'
}

const createTag = () => {
  return baseUrl + 'user/createTag'
}

const updateTag = () => {
  return baseUrl + 'user/updateTag'
}


export {
  // Authentication
  loginUrl,
  // Logs
  getLogs,
  otpVerification,

  // Users
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  transferLeads,
  getLeadRouting,
  updateLeadRouting,
  getUserDashboard,

  // Contacts
  getContacts,
  createContact,
  updateContact,
  deleteContact,

  // Properties
  getProperties,
  getProperty,
  createProperty,
  updateProperty,
  transferProperty,
  deleteProperty,

  // Leads
  getLeads,
  getLeadsExportData,
  getUniqueNames,
  getOppurtunities,
  createLead,
  updateLead,
  deleteLead,
  getPropertySuggestions,
  getLeadSuggestions,
  getLeadHistory,

  // Utils - Cities
  getCities,
  createUpdateCity,
  deleteCity,

  // Utils - Localities
  getLocalities,
  getLocalitiesByCity,
  createUpdateLocality,
  deleteLocality,

  // Utils - Amenities
  getAmenities,
  createUpdateAmenity,
  deleteAmenity,

  // Utils - Views
  getViews,
  createUpdateView,
  deleteView,

  // Utils - Source
  getSources,
  createUpdateSource,
  deleteSource,

  // Property Media
  getPropertyMedia,
  createPropertyMedia,
  updatePropertyMedia,
  deletePropertyMedia,

  // Call Attempts
  getCallAttempts,
  getCallAttemptsByDate,
  getTodaysFollowupsAndBacklogs,
  createCallAttempt,
  updateCallAttempt,
  deleteCallAttempt,

  // Follow Ups
  getSiteVisits,
  getSiteVisitsByDate,
  createSiteVisit,
  updateSiteVisit,
  deleteSiteVisit,

  // Notifications
  getNotifications,
  createNotification,
  markAsRead,

  // Dashboard
  getDashboardData,
  getDashboardLeads,
  getDashboardProperties,
  getDashboardSiteVisits,
  getDashboardCallAttempts,
  getDashboardConversions,
  getAdminDataExport,
  getDashboardOppurtunitiesConversions,
  getDashboardBacklogs,
  getDashboardStackedData,

  getTotalSourcesData,
  getSourcesData,

  // PROJECTS

  getProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject,

  // PROJECTS MEDIA

  getProjectMedia,
  createProjectMedia,
  updateProjectMedia,
  deleteProjectMedia,

  // Tags
  getTags,
  createTag,
  updateTag,

  // Usps
  createUpdateUsp,
  getUsps,
  deleteUsp,

  // Project Config
  getProjectConfig,
  getProjectConfigs,
  getProjectLeadSuggestions,
  createProjectConfig,
  updateProjectConfig,
  deleteProjectConfig


};
